import DataTable from "react-data-table-component";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { format, parseISO } from "date-fns";
import { Btn } from "../../../AbstractElements";
import { API_BASE_URL } from "../../api/api";
import { formatDate } from "../../utils/formatDate";

// El modal lo comparten el tab de bonos de influencer y el de regalias, y
// cada uno paga sobre un campo distinto del item: `influencer_bonus` vs
// `loyalty_points`. Estaba fijo en el primero, asi que en regalias se veian
// los puntos del otro bono y nunca cuadraban con el total del nivel.
export const UserOrdersModal = ({
  orderIds,
  toggle,
  ordersResponse,
  loadingOrders,
  pointsField = "influencer_bonus",
}) => {
  const selectedOrders = ordersResponse?.data?.orders || [];

  const itemPoints = (item) => (item?.[pointsField] || 0) * (item?.quantity || 0);

  const orderPoints = (order) =>
    (order?.items || []).reduce((sum, item) => sum + itemPoints(item), 0);

  const ExpandedComponent = ({ data }) => (
    <table className="table table-sm table-bordered mt-2">
      <thead className="table-light">
        <tr>
          <th style={{ width: 60 }}>Imagen</th>
          <th>Producto</th>
          <th style={{ width: 80 }}>Cantidad</th>
          <th style={{ width: 100 }}>Puntos</th>
          <th style={{ width: 100 }}>Precio</th>
        </tr>
      </thead>
      <tbody>
        {data.items?.map((item, idx) => {
          const product = item.product_id;
          const imageIndex = product?.mainImage ?? 0;
          const image = product?.images?.[imageIndex] ?? product?.images?.[0];
          const imageUrl = image ? `${API_BASE_URL}/product/get/file/${image}` : null;

          // Buscar precio según el país de la orden
          const adData = product?.aditionalData?.find(ad => ad.country_id?._id === data.country_available_id);
          const price = adData?.price_local_currency ?? item.price;

          return (
            <tr key={idx}>
              <td>
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt={product?.title || "Producto"}
                    style={{ width: 50, height: 50, objectFit: "cover", borderRadius: 4 }}
                  />
                ) : (
                  <div
                    className="text-center bg-light d-flex align-items-center justify-content-center"
                    style={{ width: 50, height: 50, borderRadius: 4 }}
                  >
                    <small>Sin imagen</small>
                  </div>
                )}
              </td>
              <td>{product?.title || "Sin nombre"}</td>
              <td>{item.quantity}</td>
              <td>{itemPoints(item)}</td>
              <td>${price?.toLocaleString() || "—"}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  const columns = [
    { name: "Usuario", selector: (row) => row.user_id?.name, sortable: true },
    { name: "Email", selector: (row) => row.user_id?.email },
    { name: "Total", selector: (row) => `$${row.total?.toLocaleString()}`, right: true },
    // Los puntos por orden se ven sin desplegar la fila: es lo que hay que
    // sumar para cuadrar contra el total del nivel.
    {
      name: "Puntos",
      selector: (row) => orderPoints(row).toLocaleString(),
      right: true,
    },
    {
      name: "Pagada",
      selector: (row) => (row.is_paid ? "Sí" : "No"),
      center: true,
    },
    {
      name: "Estado",
      selector: (row) => {
        const statusLabel = {
          CREATED: "Creada",
          PAID: "Pagada",
          PROCESSING: "En proceso",
          SHIPPED: "Enviada",
          DELIVERED: "Entregada",
          CANCELLED: "Cancelada",
        };
        return statusLabel[row.status];
      },
      center: true,
    },
    {
      name: "Fecha",
      selector: (row) => {
        if (!row.payment_paid_approval) return "—";
        try {
          return formatDate(row.payment_paid_approval);
        } catch (error) {
          return formatDate(row.payment_paid_approval);
        }
      },
      center: true,
    },
    {
      name: "Destino",
      selector: (row) =>
        row?.address_id
          ? `${row.address_id?.country_id?.name} - ${row.address_id?.province_id?.name}, ${row.address_id?.city_id?.name}`
          : row?.shipping?.country
          ? `${row.shipping?.country} - ${row.shipping?.province}, ${row.shipping?.city}`
          : "Recoger en tienda",
      wrap: true,
    },
  ];

  return (
    <Modal
      isOpen={orderIds.length > 0}
      toggle={toggle}
      size="xl"
      className="modal-dialog-scrollable"
    >
      <ModalHeader toggle={toggle} className="bg-info text-white">
        <i className="fa fa-list me-2"></i> Órdenes del usuario
      </ModalHeader>
      <ModalBody>
        {loadingOrders ? (
          <div className="text-center py-5">
            <i className="fa fa-spinner fa-spin fa-2x"></i>
          </div>
        ) : selectedOrders.length ? (
          <DataTable
            columns={columns}
            data={selectedOrders}
            pagination
            highlightOnHover
            striped
            responsive
            noDataComponent="No hay órdenes registradas"
            expandableRows
            expandableRowsComponent={ExpandedComponent} 
          />
        ) : (
          <p className="text-center text-muted">No hay órdenes registradas</p>
        )}
      </ModalBody>
      <ModalFooter>
        <Btn attrBtn={{ color: "secondary", onClick: toggle }}>
          <i className="fa fa-times me-2"></i> Cerrar
        </Btn>
      </ModalFooter>
    </Modal>
  );
};
